import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetOrderEmailRecipientRoutingMutationVariables = Types.Exact<{
  input: Types.SetOrderEmailRecipientRoutingInput;
}>;


export type SetOrderEmailRecipientRoutingMutation = { __typename?: 'Mutation', setOrderEmailRecipientRouting: { __typename?: 'OrderEmailRecipientRoutingPayload', orderEmailRecipientRouting?: { __typename?: 'OrderEmailRecipientRoutingStateData', tenantId: string, entries: Array<{ __typename?: 'OrderEmailRecipientRoutingEntryData', docType: Types.OrderEmailRecipientDocType, contactType: Types.ContactType }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearOrderEmailRecipientRoutingMutationVariables = Types.Exact<{
  input: Types.ClearOrderEmailRecipientRoutingInput;
}>;


export type ClearOrderEmailRecipientRoutingMutation = { __typename?: 'Mutation', clearOrderEmailRecipientRouting: { __typename?: 'OrderEmailRecipientRoutingPayload', orderEmailRecipientRouting?: { __typename?: 'OrderEmailRecipientRoutingStateData', tenantId: string, entries: Array<{ __typename?: 'OrderEmailRecipientRoutingEntryData', docType: Types.OrderEmailRecipientDocType, contactType: Types.ContactType }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const SetOrderEmailRecipientRoutingDocument = new TypedDocumentString(`
    mutation SetOrderEmailRecipientRouting($input: SetOrderEmailRecipientRoutingInput!) {
  setOrderEmailRecipientRouting(input: $input) {
    orderEmailRecipientRouting {
      ...OrderEmailRecipientRoutingState
    }
    errors {
      code
      message
    }
  }
}
    fragment OrderEmailRecipientRoutingState on OrderEmailRecipientRoutingStateData {
  tenantId
  entries {
    docType
    contactType
  }
}`);
export const ClearOrderEmailRecipientRoutingDocument = new TypedDocumentString(`
    mutation ClearOrderEmailRecipientRouting($input: ClearOrderEmailRecipientRoutingInput!) {
  clearOrderEmailRecipientRouting(input: $input) {
    orderEmailRecipientRouting {
      ...OrderEmailRecipientRoutingState
    }
    errors {
      code
      message
    }
  }
}
    fragment OrderEmailRecipientRoutingState on OrderEmailRecipientRoutingStateData {
  tenantId
  entries {
    docType
    contactType
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetOrderEmailRecipientRouting: build.mutation<SetOrderEmailRecipientRoutingMutation, SetOrderEmailRecipientRoutingMutationVariables>({
      query: (variables) => ({ document: SetOrderEmailRecipientRoutingDocument, variables })
    }),
    ClearOrderEmailRecipientRouting: build.mutation<ClearOrderEmailRecipientRoutingMutation, ClearOrderEmailRecipientRoutingMutationVariables>({
      query: (variables) => ({ document: ClearOrderEmailRecipientRoutingDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetOrderEmailRecipientRoutingMutation, useClearOrderEmailRecipientRoutingMutation } = injectedRtkApi;
